import { render, staticRenderFns } from "./PreviewEventBanner.vue?vue&type=template&id=b5d2a43e&scoped=true&"
import script from "./PreviewEventBanner.vue?vue&type=script&lang=js&"
export * from "./PreviewEventBanner.vue?vue&type=script&lang=js&"
import style0 from "./PreviewEventBanner.vue?vue&type=style&index=0&id=b5d2a43e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d2a43e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
